import { useState, } from "react";
import FormLoading from "../../components/loadding/FormLoading";
import Swal from "sweetalert2";
import { useNavigate, Link, useLocation, Navigate } from "react-router-dom";
import bgLogin from "../../images/bg-login.png";

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const handleVerify = async () => {
    setLoading(true);
    setErrorMessage("");

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/login/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        setErrorMessage(data.message || "Địa chỉ email không hợp lệ");
        return;
      }

      Swal.fire({
        icon: "warning",
        title: 'パスワードリセット',
        text: "パスワードリセット依頼を送信しました",
        confirmButtonText: "OK",
        confirmButtonColor: "#046DB3",
      }).then(() => {
        navigate("/admin/login");
      });

    } catch (error) {
      setErrorMessage("Địa chỉ email không hợp lệ");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div>
      <section className="sec-login !h-screen" style={{ backgroundImage: `url(${bgLogin})` }}>
        <div className="container">
          <div className="content rounded-3xl">
            <h2 className="text-center text-[2.6rem] text-[#046DB3] font-bold">Địa chỉ email</h2>

            <div className="flex justify-center flex-col gap-4 items-center mt-8">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`border w-[70%] rounded-xl px-6 py-4 text-2xl`}
              />
              {errorMessage && (
                <p className="text-center text-red-600 text-xl">
                  {errorMessage}
                </p>
              )}
              <div className="flex justify-center gap-10 items-center mt-8">
                <Link to="/login" className="hover:underline duration-300">Đã có tài khoản</Link>
                <button onClick={handleVerify} className="btn-dark !w-40">Gửi</button>
              </div>

            </div>
          </div>
        </div>
        {loading && (
          <FormLoading loading={loading} />
        )}
      </section>
    </div>
  );
};

export default ResetPassword;
